const host = process.env.NODE_ENV === 'production'
    //pro
    ?'https://open.starpos.com.cn:8180/open-platform-service'
    :'https://open.starpos.com.cn:8180/open-platform-service'

    //test
    //data/www
    // ?'https://139.196.142.43:9180/open-platform-service'
    // :'https://139.196.142.43:9180/open-platform-service'

    //dev
    // ?'http://192.168.10.27:8080/open-platform-service'
    // :'http://192.168.10.27:8080/open-platform-service'
    // ?'https://test.starpos.com.cn:9180/open-platform-service'
    // :'https://test.starpos.com.cn:9180/open-platform-service'

export const commonApi = {
    // GET
    captchaUrl: () => host + '/admin/findVerCode'

}

export const userApi = {
    // POST
    loginUrl: () => host + '/admin/login',
    //POST
    forgetPWDUrl: () => host + '/admin/forgetPWD',
    // POST
    resetPasswordUrl: () => host + '/admin/resetPWD',
    // POST
    updatePasswordUrl: () => host + '/admin/modifyPWD',
    //POST
    queryAccountUrl: () => host + '/admin/queryAccount',
    //POST
    saveAccountUrl: () => host + '/admin/saveAccount',
    //POST
    modifyEmailUrl: () => host + '/admin/modifyEmail'
}

export const appApi = {
    //POST
    infoMaintainDatialUrl: () => host + '/openerPlatform/infoMaintainDatial',
    //POST
    infoMaintainUrl: () => host + '/openerPlatform/infoMaintain',
    //POST
    saveInfoMaintainUrl: () => host + '/openerPlatform/saveInfoMaintain',
    //POST
    submitInfoMaintainUrl: () => host + '/openerPlatform/submitInfoMaintain',
    //POST
    queryAppInfoBeanListUrl: () => host + '/openerPlatform/queryAppInfoBeanList',
    //POST
    queryInfoMaintainUrl: () => host + '/openerPlatform/queryInfoMaintain',
    //POST
    recallInfoMaintainUrl: () => host + '/openerPlatform/recallInfoMaintain',
    //POST
    uploadApkUrl: () => host + '/version/fileUpload?fileType=apk',
    //POST
    uploadLogoUrl: () => host + '/version/fileUpload?fileType=logo',
    //POST
    uploadPicUrl: () => host + '/version/fileUpload?fileType=pic',
    //POST
    deleteFileUrl: () => host + '/version/delFile',
    //POST
    readAPKUrl: () => host + '/version/readAPK',
    //POST
    queryAppKeyListyUrl: () => host + '/app/queryAppKeyList',
    //POST
    creationKeyUrl: () => host + '/app/creationKey',
    //POST
    infoAppInfoDeleteUrl: () => host + '/openerPlatform/infoAppInfoDelete'
}
export const messageApi = {
    // POST  消息通知删除接口
    deleteMessageUrl: () => host + '/notify/deleteNotify',
    // POST  消息通知查询列表接口
    queryNotifyListUrl: () => host + '/notify/queryNotifyList',
    // POST 消息通知删除接口
    deleteNotifyUrl: () => host + '/notify/deleteNotify',
    // POST 消息通知新增保存接口
    creationNotifyUrl: () => host + '/notify/creationNotify',
    //消息通知修改保存接口
    updateNotifyUrl: () => host + '/notify/updateNotify',
    //消息通知修改页面返显接口
    infoNotifyDatialUrl: () => host + '/notify/infoNotifyDatial'
}

export const AXQApi = {
    // POST  注册安心签用户接口
    userAnXinQianUrl: () => host + '/anXinQianform/userAnXinQian',
    // POST  确认安心签验证码接口
    checkCodeAnXinQianUrl: () => host + '/anXinQianform/checkCodeAnXinQian',
    // POST  合同显示接口
    contractAnXinQianUrl: () => host + '/openerPlatform/contractAnXinQian',
    // POST  是否是第一次上传应用接口
    firstUploadUrl: () => host + '/admin/firstUpload'
}

export const verCodeApi = {
    // GET  验证码获取
    findVerCodeUrl: () => host + '/admin/findVerCode',
    // POST  验证码校验
    compVercodeUrl: () => host + '/admin/compVercode'
}




// WEBPACK FOOTER //
// ./src/api/api.js